/** Official HumPro app download (no UTM / referral params). */
export const HUMPRO_APP_DOWNLOAD_URL = 'https://foxxck.on-app.in/app/home?orgCode=foxxck';

export const SOCIAL_LINKS = {
  linkedin: 'https://www.linkedin.com/',
  youtube: 'https://youtube.com/@humproecosystem?si=pk3qIGyKrGAOYnrH',
  instagram: 'https://www.instagram.com/officialteamhumpro?igsh=cnlnc2d6MTcyMHFi',
  facebook: 'https://www.facebook.com/share/p/1VLJgh9ior/',
};
